import React, { useEffect } from "react";
import "@aurodesignsystem/auro-input";
import "@aurodesignsystem/auro-select";
import "@aurodesignsystem/auro-combobox";
import "./EditEventTypeInput.scss";
import "../../theme/styles.css";
import { makeStyles } from '@mui/styles';
import { EventType } from "../../Models/EventType";
import LabelInput from "../Label/Label-Input";
import { GroupPermissions} from "meportal/AuthorizationProvider";
import { useEventType } from "../../providers/EventTypeProvider";
import {EditEventTypeData} from "../../Models/EditEventTypeData";
import LockedSwitch from "./LockedSwitch";
import { InformationIconSmall } from "../svg/index"; 


interface EditEventTypeDetailsProps {
    onEditEventType: EventType | undefined;
    onEditDataChange: any; 
    handleGroupAssignments: any;
  }

 
  const useStyles = makeStyles((theme) => ({
    customCheckbox: {
      "& .MuiTypography-root": {
      fontFamily: 'var(--auro-font-family-default)',
      color: '#00274A',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 500
    }},
    customAdGroupCheckbox: { 
      "& .MuiTypography-root": {
        fontFamily: 'var(--auro-font-family-default)',
        color: '#0074CB',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 500
    }},
    customAdGroupCheckboxSelected: { 
      "& .MuiTypography-root": {
        fontFamily: 'var(--auro-font-family-default)',
        color: '#FFF',
        fontSize: '16px',
        fontStyle: 'normal',
        fontWeight: 500
    }}
  }));
  export default function EditEventTypeInput(props: EditEventTypeDetailsProps) {
    const { onEditEventType, onEditDataChange, handleGroupAssignments } = props;
    const { eventTypes } = useEventType();
   // const [groupAssignments, setGroupAssignments] = React.useState<Group[]>();
    const [eventTypeName, setEventTypeName] = React.useState("");
    const [reason, setReason] = React.useState("");
    const [isReasonValid, setIsReasonValid] = React.useState(false);
    const [category, setCategory] = React.useState("");
    const [editData, setEditData] = React.useState<EditEventTypeData>({isActive: true, isLocked: false, reasonForActiveChanged: ""});
    const [isLocked, setIsLocked] = React.useState(false);
    const [isForAirborne, setIsForAirborne] = React.useState(false);
    useEffect(() => {
      if (onEditEventType) {
        console.log("Loaded event type:", onEditEventType);
        setEventTypeName(onEditEventType.Name);
        setReason(onEditEventType.Reason);
        setCategory(onEditEventType.Category);
        setEditData({ isLocked: onEditEventType.IsLocked, isActive: onEditEventType.IsActive});
        setIsLocked(onEditEventType.IsLocked);
        setIsForAirborne(onEditEventType.IsForAirborne);
      }
    }, [onEditEventType]);
    
    const DisablePostButton = true;
    const EnablePostButton = false;

    useEffect(() => {
      validateForm();
    }, [
      eventTypeName,
      reason,
      category,
      isReasonValid
    ]);

    const validateForm = () => {
      if (
        eventTypeName != null &&
        category != null &&
        reason != null 
      ) {
        sendData(EnablePostButton);
      } else {
        sendData(DisablePostButton);
      }
    };
    const handleLockedChange = ( isOn: boolean) => {
      setIsLocked(isOn);
      console.log("Calling onEditDataChange with isLocked:", isOn)
      onEditDataChange({isLocked: isOn});
    }
    const sendData = (isSubmitDisabled: boolean) => {
      if (isSubmitDisabled) {
        const editData = {
          isSubmitDisabled: isSubmitDisabled,
        };
        onEditDataChange(editData);
      } else {
        const editData = {
          name: eventTypeName,
          reason: reason,
          catgeory: category,
          isSubmitDisabled: isSubmitDisabled,
          isActive: onEditEventType?.IsActive,
          isLocked: isLocked,
        };
        onEditDataChange(editData);
      }
    };
  
    return (
      <React.Fragment>
      <div>
          <div className="sectionHeaderLabel">Event type details </div>        
          <div className="edit-event-type-list">
            <LabelInput labelTitle="Event type name" labelContent={onEditEventType?.Name} />
            <LabelInput labelTitle="Legacy category" labelContent={onEditEventType?.Category} />
          </div>
          <div className="reason-container modalInput spacing-top">
            <LabelInput labelTitle="Reason for event type" labelContent={onEditEventType?.Reason} />
          </div>
          <div>
          { !isForAirborne && 
             <LockedSwitch toggleSwitch={handleLockedChange} isOn={isLocked} />
          }
          {isForAirborne && 
            <div className="modalInput isForAirborneLabel">
              <span className="isForAirborneIcon">
                <InformationIconSmall /> 
              </span>
              <span className="isForAirborneIcon">This event type can not be deactivated </span>
            </div>
          }
          </div>

            </div>
                {onEditEventType && onEditEventType.Airline && onEditEventType.Name && 
                <GroupPermissions 
                  applicationName="OutOfServiceRecovery"
                  eventId={onEditEventType?.Airline + ":" + onEditEventType?.Name}
                  setGroups={handleGroupAssignments}
                  isModal = {true}
                  eventTypes = {eventTypes}
                /> }
      </React.Fragment>
    );
  }
  